import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { gameDataContext } from '@/providers/GameDataProvider';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description: string;
};

export const StartGamePopup = ({
  title,
  description,
  isOpen,
  onClose,
}: Props) => {
  const { t } = useTranslation();
  const { currentGameIndex } = useContext(gameDataContext);
  return (
    <Dialog
      open={isOpen}
      defaultOpen={false}
      onOpenChange={(open) => {
        console.log('open', open);
        if (!open) onClose();
      }}
    >
      <DialogContent
        className="w-11/12 max-w-[425px] bg-primary py-10 text-center sm:w-full"
        //prevent close on click outside
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDown={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <div className="absolute -top-8 left-1/2 flex w-40 -translate-x-1/2 items-center justify-center">
            <img
              alt="header"
              src="content/images/startPopup_header.svg"
              className="absolute"
            />
            <div className="z-10 -mt-3 text-6xl font-bold">
              {currentGameIndex + 1 || '0'}
            </div>
          </div>
          <DialogTitle className="pt-6">{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button type="submit" onClick={onClose} variant="secondary">
            {t('popup.startGame.start')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
